import { Link } from 'react-router-dom';
import { Instagram, Twitter, Youtube } from 'lucide-react';

export function Footer() {
  return (
    <footer className="bg-[#2173B9] text-white">
      <div className="max-w-7xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center space-y-8">
          {/* Logo */}
          <Link to="/" className="text-2xl font-bold">
            MOLDE STADION
          </Link>

          {/* Language Selection */}
          <div className="flex items-center gap-4">
            <a 
              href="https://moldestadion.no"
              className="flex items-center gap-2 hover:opacity-80 transition-opacity"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Norwegian version"
            >
              <img 
                src="/images/flags/no.svg" 
                alt="Norwegian" 
                className="w-8 h-8 rounded-full border-2 border-white"
              />
              <span className="text-sm">Norwegian</span>
            </a>
            <a 
              href="/"
              className="flex items-center gap-2 hover:opacity-80 transition-opacity"
              aria-label="English version"
            >
              <img 
                src="/images/flags/gb.svg" 
                alt="English" 
                className="w-8 h-8 rounded-full border-2 border-white"
              />
              <span className="text-sm">English</span>
            </a>
          </div>

          {/* Social Links */}
          <div className="flex space-x-6">
            <a
              href="https://www.instagram.com/moldefotballklubb/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white/80"
              aria-label="Instagram"
            >
              <Instagram className="h-6 w-6" />
            </a>
            <a
              href="https://x.com/Molde_FK"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white/80"
              aria-label="X (Twitter)"
            >
              <Twitter className="h-6 w-6" />
            </a>
            <a
              href="https://www.youtube.com/channel/UCP8HqD2euT1TUgXWVaT1fiQ"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white/80"
              aria-label="YouTube"
            >
              <Youtube className="h-6 w-6" />
            </a>
          </div>

          {/* Legal Links */}
          <div className="flex space-x-6 text-sm text-white/80">
            <Link to="/privacy" className="hover:text-white">
              Privacy Policy
            </Link>
            <Link to="/terms" className="hover:text-white">
              Terms & Conditions
            </Link>
          </div>

          {/* Copyright */}
          <div className="text-sm text-white/80">
            © {new Date().getFullYear()} Molde Stadion. Your source for information about Molde FK's proud football arena. This website is not affiliated with Molde FK or Molde municipality.
          </div>
        </div>
      </div>
    </footer>
  );
}
